import { Stack } from '@mui/material'
import { ReservableScheduleEmptyAlert } from './ReservableSchedulesEmptyAlert'
import { PageContainer } from '~/components/common/PageContainer'
import { ResponsiveWaitingCampaignList } from './ResponsiveWaitingCampaignList'
import { ResponsiveApprovedCampaignList } from './ResponsiveApprovedCampaignList'

export const CampaignsContent = () => {
  return (
    <PageContainer>
      <Stack gap={3} mb={3}>
        <ReservableScheduleEmptyAlert />
        <ResponsiveWaitingCampaignList />
        <ResponsiveApprovedCampaignList />
      </Stack>
    </PageContainer>
  )
}
